import { axiosInstanceWithCredentials } from "./base";

export function getGames(params) {
    return axiosInstanceWithCredentials.get("/games", {
        params
    });
}
export function deleteGame(id) {
    return axiosInstanceWithCredentials.delete(`/game/${id}/`);
}
export function addAwardTrophy(data) {
    return axiosInstanceWithCredentials.post(`/game/${data.gameId}/tournament/${data.tournamentId}/trophy/${data.trophyId}/`)
}

export function getGameTrophies(id,params) {
    return axiosInstanceWithCredentials.get(`/game/${id}/trophies`, {
        params
    });
}

export function deleteGameTrophy(id,params) {
    return axiosInstanceWithCredentials.delete(`/gametrophy/${id}/`, {
        params
    });
}
